export default {
  // 按钮文本
  addButton: '新增',
  editButton: '编辑',
  deleteButton: '删除',
  cancelButton: '取消',
  confirmButton: '确定',

  // 表格列标题
  roleNameColumn: '角色名称',
  roleKeyColumn: '权限字符',
  useTypeColumn: '使用类型',
  statusColumn: '状态',
  createTimeColumn: '创建时间',
  actionColumn: '操作',

  // 使用类型
  useTypePc: '电脑端',
  useTypeMobile: '手机端',

  // 状态
  statusNormal: '正常',
  statusDisabled: '停用',
  statusYes: '是',
  statusNo: '否',

  // 表单标签
  roleNameLabel: '角色名称',
  roleKeyLabel: '权限字符',
  orderNumLabel: '角色顺序',
  useTypeLabel: '使用类型',
  statusLabel: '状态',
  menuPermsLabel: '菜单权限',

  // 表单placeholder
  roleNamePlaceholder: '请输入角色名称',
  roleKeyPlaceholder: '请输入权限字符',
  orderNumPlaceholder: '填写排序',

  // 验证消息
  roleNameRequired: '请输入角色名称',
  roleKeyRequired: '请输入权限字符',
  orderNumRequired: '请输入排序',
  useTypeRequired: '请选择使用类型',
  statusRequired: '请选择状态',

  // 弹窗标题
  addRoleTitle: '新增角色',
  editRoleTitle: '修改角色',

  // 确认对话框
  deleteConfirm: '是否删除 {name}',

  // 成功消息
  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',
}
